module.exports = __webpack_public_path__ + "static/img/oracle.390b9ef8.png";